import { dateConverter } from "./DateConverter";
import { DataPickerProps } from "./DatePicker";

export const datePickerTestPageObject = (props: DataPickerProps) => ({
    getType: () => "DatePicker",

    getValue: () => dateConverter.toModel(props.value),

    setValue: (value: string) => {
        props.onChange(dateConverter.toControl(value) ?? "");
    },
});
